module.exports = __webpack_public_path__ + "static/mentoring-project-rebound-students-67c7f23eca5739d8a495fa5edbb2b7c5.jpg";